import {INSTANCE_CONFIGURATION} from "./route/configurationController";
import {InstanceConfigurationModuleConfiguration} from "./instanceConfigurationModuleConfiguration";
import {BrandPickerComponent} from "./component/brand-picker/brand-picker.component";

InstanceConfigurationModuleConfiguration
    .createNewModule()
    .component('brandPicker', BrandPickerComponent.instance)
    .controller('configurationController', INSTANCE_CONFIGURATION);